/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.amount} €`
};

const en_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.amount}€`
};

const es_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.amount} €`
};

const fr_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.amount} €`
};

const it_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `€ ${i.amount}`
};

const nl_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.amount} €`
};

const pt_poi_filters__value_label__price__eur = /** @type {(inputs: { amount: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.amount} €`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ amount: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__eur = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__value_label__price__eur(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__value_label__price__eur", locale)
	if (locale === "de") return de_poi_filters__value_label__price__eur(inputs)
	if (locale === "en") return en_poi_filters__value_label__price__eur(inputs)
	if (locale === "es") return es_poi_filters__value_label__price__eur(inputs)
	if (locale === "fr") return fr_poi_filters__value_label__price__eur(inputs)
	if (locale === "it") return it_poi_filters__value_label__price__eur(inputs)
	if (locale === "nl") return nl_poi_filters__value_label__price__eur(inputs)
	return pt_poi_filters__value_label__price__eur(inputs)
};